import React from 'react'
import {Form} from "@redriver/cinnamon";

const NonPropagatingDate = (props) => {
    return (
        <Form.Date {...props} onKeyDown={(e) => e.stopPropagation()}/>
    )
}
export default NonPropagatingDate
